import React from 'react';
import { string as stringType, shape as shapeType } from 'prop-types';
import { BannerRenderer } from './BannerRenderer';
import { MedioInline } from './MedioInline';

const MedioInlinePreview = ({ componentId, componentClass, livePreviewData }) => {

  return (
    livePreviewData
      ? (
        <BannerRenderer
          componentId={componentId}
          componentClass={componentClass}
          data={livePreviewData}
          mobileAspectRatio="sui-aspect-[640/241]"
          tabletAspectRatio="md:sui-aspect-[142/15]"
          desktopAspectRatio="xl:sui-aspect-[142/15]"
        />
      )
      : (
        <MedioInline
          componentId={componentId}
          componentClass={componentClass}
        />
      )
  );
};

MedioInlinePreview.propTypes = {
  componentClass: stringType,
  componentId: stringType.isRequired,
  livePreviewData: shapeType({})
};

MedioInlinePreview.defaultProps = {
  componentClass: '',
  livePreviewData: null
};

MedioInlinePreview.displayName = 'MedioInlinePreview';

export { MedioInlinePreview };
